export default __webpack_public_path__ + "static/media/puesto.8823bcfd.png";